import React, { useState, useContext, useEffect, useRef } from "react"
import { Link } from "gatsby"

import { PastIssuesContext } from "../../contexts/PastIssues"

import Style from "./header.module.scss"
import Styled from "styled-components"

/**
 * Header (Default): Header for all the archive issues
 */
const Header = props => {
  return (
    <>
      <header className={Style.archiveHeader}>
        <LeftHeader />
        <RightHeader />
      </header>
      <PastArchiveMenu archiveMenuData={props.archiveMenuData} />
    </>
  )
}

export default Header

/* ===================================================*/

/**
 * LeftHeader: Left side of the header. Contains link back to
 * landing page of archive Contains and link to issues of the archive
 */
const LeftHeader = () => {
  // Visibility of drop down menu for past issues of the archive
  const [pastIssuesVisibility, setPastIssuesVisibility] = useContext(
    PastIssuesContext
  )
  // State for changing hamburger color onHover and while menu is open
  const [hamburgerColor, setHamburgerColor] = useState("#FFFFFF")
  const [lineColor, setLineColor] = useState("#000000")

  return (
    <div className={Style.headerLeftNav}>
      <Link to="/">
        <h1>WET INK ARCHIVE</h1>
      </Link>
      <button
        className={Style.hamburger}
        style={{ background: hamburgerColor }}
        // Hamburger hover highlighting
        onClick={() => {
          wouldYouLikeFriesWithThat()
        }}
        onMouseEnter={() => {
          setLineColor("#FFFFFF")
          setHamburgerColor("#000000")
        }}
        onMouseLeave={() => {
          if (pastIssuesVisibility === false) {
            setLineColor("#000000")
            setHamburgerColor("#FFFFFF")
          }
        }}
      >
        <div
          className={Style.line}
          style={{ background: lineColor, transition: "0.3s" }}
        />
        <div
          className={Style.line}
          style={{ background: lineColor, transition: "0.3s" }}
        />
        <div
          className={Style.line}
          style={{ background: lineColor, transition: "0.3s" }}
        />
      </button>
    </div>
  )

  // Hamburger onClick() function
  function wouldYouLikeFriesWithThat() {
    // Open/close past issues menu
    pastIssuesVisibility === true
      ? setPastIssuesVisibility(false)
      : setPastIssuesVisibility(true)

    // Change hamburger color
    let burgerBg = "#FFFFFF",
      burgerToppings = "#000000"
    if (pastIssuesVisibility === false) {
      burgerBg = "#000000"
      burgerToppings = "#FFFFFF"
    }
    setHamburgerColor(burgerBg)
    setLineColor(burgerToppings)
  }
}

/**
 * Right: Right side of the header. Contains link back to wetink.org
 */
const RightHeader = () => {
  return (
    <div className={Style.headerRightNav}>
      <h1>
        <a
          href="http://www.wetink.org"
          style={{
            paddingLeft: "3%",
            paddingTop: "1%",
            position: "relative",
            float: "right",
          }}
        >
          WETINK.ORG
        </a>
      </h1>
    </div>
  )
}

const PastArchiveMenu = props => {
  // Visibility of drop down menu for past issues of the archive
  const [pastIssuesVisibility] = useContext(PastIssuesContext)

  const [height, setHeight] = useState(null)

  // Negative height for dropdown menu hiding
  const menu = useRef(null)

  useEffect(() => {
    setHeight(menu.current.offsetHeight)
  }, [])

  return (
    <DropDownMenu
      visiblilty={pastIssuesVisibility}
      ref={menu}
      style={{
        top:
          pastIssuesVisibility === true
            ? DropDownMenu.top
            : "-" + height + "px",
      }}
    >
      <ul>
        {props.archiveMenuData.edges.map((edge, id) => {
          return (
            <Link to={`/${edge.node.slug}`} key={id}>
              <li>
                <i>{edge.node.title.toUpperCase()}</i>
              </li>
            </Link>
          )
        })}
      </ul>
    </DropDownMenu>
  )
}

/**
 * DropDownMenu: Styled component for
 * past archive menu component
 */
const DropDownMenu = Styled.div`
    visibility: ${props => (props.visiblilty === true ? "visible" : "hidden")};
    background-color: #ffffff;
    position: absolute;
    overflow: hidden;
    top: ${props => (props.visiblilty === true ? "5.5vw" : "0")};
    height: auto;
    border-bottom: 5px solid #afaea2;
    width: 100vw;
    overflow: scroll;
    z-index: 4;
    transition: 0.5s ease-out;
    ul {
      width: 100vw;
      height: auto;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    li {
      width: 100vw;
      height: auto;
      border-bottom: 1px solid #000000;
      padding: 1%;
      list-style: none;
      font-size: 2vw;
      cursor: pointer;
      &:hover {
        color: #ffffff;
        background-color: #000000;
      }
    }
  
  /**
   * iPads
   */
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    top: 8vw;
    li {
      font-size: 4vw;
    }
  }

  /**
   * iPhones
   */
  @media only screen and (max-width: 767px) {
    top: 15vw;
    li {
      font-size: 5vw;
    }
  }
`
